/**
 * Удаляет query-параметр по ключу.
 *
 * @param {string} queryKey - Ключ, по которому будет удаление.
 *
 * */

export const deleteSearchParams = (queryKey: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(queryKey);
    const newUrl = `${window.location.pathname}${
        searchParams.toString() ? '?' + searchParams.toString() : ''
    }`;
    window.history.replaceState(null, '', newUrl);
};
